export const getSliderButtonBaseHeight = (activeCell: HTMLElement, positionLogic: string): number | false => {
  const selector = positionLogic === 'image'
    ? 'figure img'
    : positionLogic === 'video'
      ? '.bx-content__media-video-placeholder img, video'
      : 'div'

  return activeCell.querySelector<HTMLElement>(selector)?.clientHeight || false
}
